import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { logger } from '../utils/logger';

const PrivateRoute: React.FC = () => {
  const token = localStorage.getItem('counterparty_token');
  const counterparty = localStorage.getItem('counterparty');

  // console.log("[PrivateRoute] Checking authentication:", {
  //   hasToken: !!token,
  //   hasCounterparty: !!counterparty,
  //   tokenLength: token?.length,
  //   counterpartyLength: counterparty?.length,
  //   localStorageKeys: Object.keys(localStorage),
  // });

  logger.debug("[PrivateRoute] Checking authentication:", {
    hasToken: !!token,
    hasCounterparty: !!counterparty,
    counterpartyData: counterparty,
  });

  if (!token || !counterparty) {
    // console.log("[PrivateRoute] Authentication failed, redirecting to login");
    logger.warn("[PrivateRoute] Authentication failed, redirecting to login");
    localStorage.removeItem('counterparty_token');
    localStorage.removeItem('counterparty');
    return <Navigate to="/counterparty/login" replace />;
  }

  logger.debug(
    "[PrivateRoute] Authentication successful, rendering protected content",
  );
  return <Outlet />;
};

export default PrivateRoute;
